/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReferenceMetricsDTO } from './referenceMetricsDTO';


export interface GeoCampaignListingRequestDTO { 
    /**
     * Measured client identifier
     */
    clientId: number;
    /**
     * Brand identifier within the client
     */
    brandId: number;
    /**
     * Conversion type IDs to filter campaigns for
     */
    conversionTypeIds: Array<number>;
    /**
     * Tactic names to fetch campaigns for
     */
    tactics: Array<string>;
    /**
     * Platform vendor name for campaign filtering
     */
    vendor: string;
    /**
     * Reference period start as Unix timestamp in milliseconds
     */
    referencePeriodStartDate: number;
    /**
     * Reference period end as Unix timestamp in milliseconds
     */
    referencePeriodEndDate: number;
    /**
     * Test start date as Unix timestamp in milliseconds for schedule validation
     */
    studyStartDate?: number;
    /**
     * Test end date as Unix timestamp in milliseconds for schedule validation
     */
    studyEndDate?: number;
    /**
     * Geographic granularity level (e.g. DMA, REGION, CITY, ZIP)
     */
    geoSplitType?: string;
    /**
     * Geo test type for determining campaign selection rules
     */
    testType?: GeoCampaignListingRequestDTO.TestTypeEnum;
    /**
     * Target daily scale cost for scale-type tests
     */
    scaleCost?: number;
    /**
     * Planned test duration in days for spend calculations
     */
    testDurationInDays?: number;
    referenceMetrics?: ReferenceMetricsDTO;
    /**
     * Design-space model simulation ID for linking campaign data to test configuration
     */
    dsMdlSimulationId?: number;
    /**
     * Whether the platform supports automatic campaign synchronization
     */
    isSupportedBySyncTool?: boolean;
    /**
     * User-selected inventory items for campaign filtering
     */
    userSelectedInventory?: Array<string>;
    /**
     * Cell size as a decimal fraction (e.g. 0.15 for 15%) used for SMNS normalization
     */
    cellSize?: number;
    /**
     * Account types for platform configuration matching (matches platform_identifier in cp_doe_platforms)
     */
    accountTypes?: Array<string>;
}
export namespace GeoCampaignListingRequestDTO {
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


